import React, { useEffect, useState } from 'react'
import { Redirect, useHistory } from 'react-router-dom'
import { ICircle } from 'daily-dose-common'
import { firestore } from '../../firebase-init'
import { AddDoseForm, Loading, MyCircleDetailsItem } from '../../components'
import AddMember from '../../components/add-member'
import { useDialog } from '../../providers/dialog-provider'
import { collectIdAndDocs } from '../../utilities'
import { EditCircleModal } from '../../modals'

// TODO: Add a currentMembers array of objects storing the users data in firestore under the circle collection

export interface IMyCircleDetailPage<P> {
  match: IMatch<P>
  location: any
  history: any
  staticContext?: any
}

export interface IMatch<P> {
  params: P
  isExact: boolean
  path: string
  url: string
}

interface IMatchParams {
  id: string
}

const MyCircleDetailPage = (route: IMyCircleDetailPage<IMatchParams>) => {
  const { openDialog, closeDialog } = useDialog()
  const history = useHistory()
  const circleId = route.match.params.id
  const circleRef = firestore.collection('circles').doc(circleId)

  const [selectedCircle, setSelectedCircle] = useState({} as any)
  const [circleExist, setCircleExist] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const unsubscribeCircleRefFromFirestore = circleRef.onSnapshot((snapshot) => {
      if (snapshot.exists) {
        setSelectedCircle(collectIdAndDocs(snapshot) as ICircle)
        setCircleExist(true)
        setLoading(false)
      } else {
        setCircleExist(false)
        setLoading(false)
      }
    })
    return () => {
      unsubscribeCircleRefFromFirestore()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onGoToAddDose = () => {
    const circleId = selectedCircle.id
    const doseRef = firestore.collection(`circles/${circleId}/doses`)
    openDialog({
      color: 'primary',
      title: 'Add a dose',
      confirmText: 'ADD',
      custom: true,
      description: (
        <AddDoseForm
          doseRef={doseRef}
          onAddDose={() => closeDialog()}
          circle={selectedCircle}
          onCancelDose={() => closeDialog()}
        />
      ),
      onClose: () => true,
      // onConfirm: () => true,
      fullScreen: true,
    })
  }

  const onGoToAddAMember = () => {
    openDialog({
      color: 'primary',
      title: 'Add a member',
      confirmText: 'Add',
      custom: true,
      description: (
        <AddMember
          selectedCircle={selectedCircle}
          circleId={circleId}
          onAddMember={() => closeDialog()}
          onCancel={() => closeDialog()}
        />
      ),
      onClose: () => true,
      fullScreen: true,
    })
  }

  const onGoToEditCircle = () => {
    openDialog({
      color: 'primary',
      title: 'Edit group',
      confirmText: 'Update',
      custom: true,
      description: (
        <EditCircleModal
          selectedCircle={selectedCircle}
          onUpdateCircle={() => closeDialog()}
          onCancelCircle={() => closeDialog()}
        />
      ),
      fullScreen: true,
    })
  }

  const onGoToTodaysDose = () => {
    history.push(`/my-circles/${circleId}/today-dose`)
  }

  const onGoToPastDoses = () => {
    history.push(`/my-circles/${circleId}/past-doses`)
  }

  const onGoToMembers = () => {
    history.push(`/my-circles/${circleId}/members`)
  }

  if (loading) {
    return <Loading />
  }

  if (!circleExist) {
    return <Redirect to="/" />
  }

  return (
    <MyCircleDetailsItem
      circle={selectedCircle}
      onGoToAddAMember={onGoToAddAMember}
      onGoToAddDose={onGoToAddDose}
      onGoToEditCircle={onGoToEditCircle}
      onGoToMembers={onGoToMembers}
      onGoToTodaysDose={onGoToTodaysDose}
      onGoToPastDoses={onGoToPastDoses}
    />
  )
}

export default MyCircleDetailPage
